import { getCSRFToken } from './csrf';

let sessionToken:any;
let appBridgeReady = false;

export async function getFetch(url:string, body:any) {
  try {
    await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'GET',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
  });
}

export async function postFetch(url:string, body:any) {
  try {
    await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
    return fetch(url, {
        credentials: 'include',
        method: 'POST',
        mode: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCSRFToken(),
          'Authorization': 'Bearer ' + sessionToken
        },
        body: JSON.stringify(body)
    });
}

export async function deleteFetch(url:string, body:any) {
  try {
    await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'DELETE',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
}

export async function putFetch(url:string, body:any) {
  try {
    await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  console.log('putFetch: sending PUT to', url);
  const response = await fetch(url, {
      credentials: 'include',
      method: 'PUT',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
  console.log('putFetch: response received, status:', response.status);
  return response;
}
export async function patchFetch(url:string, body:any) {
  try {
    await getSessionTokenFromAppBridge();
  } catch (e) {
    return(e);
  }
  url = addSlashToURLWhereNecessary(url);
  return fetch(url, {
      credentials: 'include',
      method: 'PATCH',
      mode: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
        'Authorization': 'Bearer ' + sessionToken
      },
      body: JSON.stringify(body)
  });
}

export async function initAppBridge() {
  if (appBridgeReady) return;
  appBridgeReady = true;
}

async function getSessionTokenFromAppBridge() {
  await initAppBridge();
  try {
    sessionToken = await Promise.race([
      (window as any).shopify.idToken(),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('idToken_timeout')), 3000)
      )
    ]);
  } catch (e) {
    throw e;
  }
}

function addSlashToURLWhereNecessary(url: string) {
  if (!url.endsWith('/') && url.indexOf('?') === -1) {
    return url + '/';
  } else {
    return url;
  }
}
